import { Injectable } from '@angular/core';
import { MigrationSniperInterface, MigrationSnipeStatusEnum } from './migration-sniper.interfaces';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { MigrationSniperApiService } from '@core/services/migration-sniper.api.service';

@Injectable()
export class MigrationSniperService {
    private readonly migrationSnipersSubject$ = new BehaviorSubject<MigrationSniperInterface[]>([]);
    migrationSnipers$ = this.migrationSnipersSubject$.asObservable();

    constructor(private readonly migrationSniperApiService: MigrationSniperApiService) {}

    updateMigrationSnipers(): Observable<MigrationSniperInterface[]> {
        return this.migrationSniperApiService.getList().pipe(
            tap((migrationSnipers) => {
                this.migrationSnipersSubject$.next(migrationSnipers);
            }),
        );
    }

    archiveMigrationSniper(migrationSniperId: number): Observable<void> {
        return this.migrationSniperApiService.archive(migrationSniperId).pipe(
            tap(() => {
                this.migrationSnipersSubject$.next(
                    this.migrationSnipersSubject$.value.map((migrationSniper) => {
                        if (migrationSniper.id === migrationSniperId) {
                            return {
                                ...migrationSniper,
                                status: MigrationSnipeStatusEnum.archived,
                            };
                        }
                        return migrationSniper;
                    }),
                );
            }),
        );
    }
}
